import { useState, useEffect } from "react";
import {
  Navbar,
  Nav,
  NavItem,
  NavLink,
  NavbarToggler,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUserCircle } from "@fortawesome/free-solid-svg-icons";
import logo_ah from "../../IMG/media/LOGOTYPES/MyActivHub/Web/PNG/logoType_light.png";
import weexa from "../../IMG/weexa.png.webp";
import afer from "../../IMG/afer.png";
import IRM from "../../IMG/IMF.png";
import { useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
import "./nav.css";
import { setEnvironmentColors } from "../Utils/EnvironnementColor";
import { useTranslation } from "react-i18next";
import config from "../config.json";
import navbarConfig from "./NavbarConfig.json";
import fr from "../../IMG/fr-FR.png";
import en from "../../IMG/en-EN.png";

export default function NavBar() {
  const [isOpen, setIsOpen] = useState(false);
  const [headerColor, setHeaderColor] = useState("#235073");
  const navigate = useNavigate();
  const toggle = () => {
    setIsOpen(!isOpen);
  };

  const Nom = Cookies.get("Username");
  const Family_name = Cookies.get("Family_name");
  const Role = Cookies.get("Role");
  const Client = Cookies.get("Client");
  const Environnement = Cookies.get("Env");

  // Filtrage dynamique des entrées du menu selon le rôle et le client
  const filteredMenu = navbarConfig.filter((item) => {
    const matchRole = !item.role || item.role === Role;
    const matchClient = !item.client || item.client === Client;
    return matchRole && matchClient;
  });

  // Déconnexion : suppression des données locales et des cookies, puis redirection
  const handleLogout = () => {
    localStorage.clear();
    Object.keys(Cookies.get()).forEach((cookieName) => {
      Cookies.remove(cookieName);
    });
    navigate("/");
  };

  // Définir la couleur de l'en-tête au montage selon l'environnement
  useEffect(() => {
    setEnvironmentColors([[setHeaderColor, "headerColor"]]);
  }, []);

  const { i18n } = useTranslation();
  const { t } = useTranslation();

  // Changement de langue et enregistrement dans le localStorage
  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
    localStorage.setItem("i18nextLng", lng);
  };

  // Logos spécifiques selon le nom de famille enregistré
  const userLogos = {
    Invoices: weexa,
    Classification: afer,
  };

  const logo = userLogos[Family_name];

  return (
    <div className="nav-container">
      <Navbar
        dark
        className="custom-navbar"
        style={{ backgroundColor: headerColor, marginBottom: 0 }}
      >
        <NavbarToggler onClick={toggle} />
        <div
          style={{ color: "white", display: "flex", alignItems: "flex-end" }}
        >
          <img
            src={config["IMF-DEV"] ? IRM : logo_ah}
            alt="Logo"
            className="logo"
            style={{ height: "30px", width: "auto", marginRight: "10px" }}
          />
          <div style={{ fontWeight: "bold", marginBottom: "0px" }}>
            {Environnement}
          </div>
        </div>
        <div className="user-info ml-auto d-flex align-items-center">
          <div
            style={{
              display: "flex",
              alignItems: "center",
              marginRight: "8px",
            }}
          >
            {logo ? (
              <img src={logo} alt={`${Nom} logo`} style={{ height: "24px" }} />
            ) : (
              <FontAwesomeIcon
                icon={faUserCircle}
                style={{ height: "24px", color: "white" }}
              />
            )}
          </div>

          <font style={{ color: "white", marginRight: "12px" }}>
            {Nom} {Family_name}
          </font>
          <div
            style={{
              display: "flex",
              gap: "4px",
              justifyContent: "center",
            }}
          >
            {["fr", "en"].map((lang) => (
              <img
                key={lang}
                src={lang === "fr" ? fr : en}
                alt={lang}
                style={{
                  width: "24px",
                  height: "24px",
                  cursor: "pointer",
                  border:
                    localStorage.getItem("i18nextLng") === lang
                      ? "2px solid #054f5cff"
                      : "2px solid transparent",
                  backgroundColor:
                    localStorage.getItem("i18nextLng") === lang
                      ? "#054f5cff"
                      : "transparent",
                  borderRadius: "4px",
                }}
                onClick={() => changeLanguage(lang)}
              />
            ))}
          </div>
          <UncontrolledDropdown setActiveFromChild>
            <DropdownToggle
              tag="a"
              style={{ width: "24px", height: "24px", justifyContent: "center" }}
              className="nav-link d-flex align-items-center"
              caret
            ></DropdownToggle>

            <DropdownMenu end className="p-2">
              <DropdownItem onClick={handleLogout}>{t("LogOut")}</DropdownItem>
            </DropdownMenu>
          </UncontrolledDropdown>
        </div>

        <div
          className={`sidebar ${isOpen ? "open" : ""}`}
          style={{ backgroundColor: headerColor }}
        >
          <Nav navbar vertical style={{ width: "100%" }}>
            {filteredMenu.map((item, index) => (
              <NavItem
                key={`nav-${index}`}
                className="nav_item_position"
                data-type={index === 0 ? "premier" : undefined}
              >
                <NavLink className="nav_text" href={item.href}>
                  {t(item.label)}
                </NavLink>
              </NavItem>
            ))}
          </Nav>
        </div>
      </Navbar>
    </div>
  );
}
